import { useMemo, useState } from 'react';
import upperCase from 'lodash/upperCase';

import { useTranslation } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';
import { FilterGroup } from '@/components/Filter/types';
import useSubworkspaces from '@/modules/corporate/modules/workspaceSettings/hooks/useSubworkspaces';

export default function useSubworkspacesFilter() {
  const { t } = useTranslation();
  const { subWorkspaces, fetching, error } = useSubworkspaces();
  const [searchStr, setSearchStr] = useState('');
  const workspaceOptions = useMemo(
    () =>
      subWorkspaces?.length
        ? subWorkspaces.map((subWorkspace) => ({
            value: subWorkspace.id,
            label: subWorkspace.name,
          }))
        : [],
    [subWorkspaces],
  );

  const filteredOptions = workspaceOptions.filter((option) =>
    option.label.toLowerCase().includes(searchStr.toLowerCase()),
  );

  const filterGroups: FilterGroup[] = useMemo(
    () =>
      filteredOptions?.length
        ? [
            {
              id: 'subWorkspaces',
              label: (
                <Typography color="text-text-placeholder" variant="label-caps">
                  {upperCase(t('Common:Filter.SelectAll'))}
                </Typography>
              ),
              options: filteredOptions,
            },
          ]
        : [],
    [filteredOptions, t],
  );

  return {
    state: {
      filterGroups,
      searchStr,
      fetching,
      error,
    },
    methods: {
      setSearchStr,
    },
  };
}
